import { AccountSupplyPointFragmentFragment } from '../api/kapi/__generated__/graphql';

export const mapOhsClassifySearchAddress = (
  supplyPoints: AccountSupplyPointFragmentFragment[] | undefined,
) => {
  if (!supplyPoints?.length) return undefined;

  const electricitySupplyPoints = supplyPoints.filter(supply => {
    return supply.supplyPoint.fuelType === 'ELECTRICITY';
  });

  const supplyPoint = electricitySupplyPoints.find(
    supplyPoint => supplyPoint.supplyPoint.address?.addressLines?.length,
  )?.supplyPoint;

  const supplyPointAddressLines = supplyPoint?.address?.addressLines;

  if (!supplyPointAddressLines) return undefined;

  const postCode = supplyPoint?.address?.postCode ?? undefined;

  if (!supplyPointAddressLines.length) {
    return {
      postCode,
      addressLine1: undefined,
    };
  }

  if (isOnlyNumber(supplyPointAddressLines[0])) {
    const isHouseNumberInAddressLine1 = supplyPointAddressLines[1].includes(
      supplyPointAddressLines[0],
    );

    if (isHouseNumberInAddressLine1) {
      return {
        addressLine1: supplyPointAddressLines[1],
        postCode,
      };
    }

    const houseNumber = parseInt(supplyPointAddressLines[0]);

    return {
      addressLine1: houseNumber + ' ' + supplyPointAddressLines[1],
      postCode,
    };
  }
  return {
    addressLine1: supplyPointAddressLines[0],
    postCode,
  };
};

function isOnlyNumber(str: string) {
  return /^[0-9]+$/.test(str);
}
